import { get } from 'lodash'

export default {
  'FEE-WAIVER': (user) => {
    return get(user, 'HighSchoolStudentId', false) && get(user, 'DocumentRequirements.NeedsToSignFeeWaiver', false)
  },
}
